var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBannerCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17.25,
    height: 17.25,
    rx: 8.625,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88013 11.3672C6.05652 11.5436 6.35286 11.5366 6.5222 11.3708L8.62481 9.26817L10.7239 11.3708C10.8968 11.5436 11.1931 11.5436 11.366 11.3672C11.5388 11.1909 11.5424 10.898 11.3695 10.7252L9.27041 8.62257L11.3695 6.52348C11.5424 6.35062 11.5424 6.05781 11.366 5.88141C11.1896 5.70855 10.8968 5.70502 10.7239 5.87788L8.62481 7.98049L6.5222 5.87788C6.35286 5.71208 6.05299 5.70502 5.88013 5.88141C5.70726 6.05781 5.71079 6.35415 5.8766 6.51996L7.97921 8.62257L5.8766 10.7287C5.71079 10.8945 5.70373 11.1944 5.88013 11.3672Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerCloseIcon);
export default __webpack_public_path__ + "static/media/banner_close_icon.f9174cb4c0017534dce5bab362c7ec94.svg";
export { ForwardRef as ReactComponent };